import { getConfigWithLang, userEnv } from '@tencent/wphk-base-utils';
import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { language } from '@tencent/ppd-base-libs';
import { HOME_DP_PAGE_ID } from '@/constant/dp';
import { MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';
import { ref } from '@vue/composition-api';

/** 苹果Banner投放位ID */
const APPLE_BANNER_DP_ID = '1100040000460005';
/** 最大banner数量 */
const MAX_BANNER_COUNT = 1;

export type BannerInfo = {
  id: string;
  osType: ('android' | 'ios')[];
  icon: string;
  promType: string;
  promTypeColor: string;
  promTitle: string;
  promBtnText: string;
  promBtnColor: string;
  promBGColor: string;
  jumpInfo: MultiJumpInfo;
};

/** OS type 映射 */
const osMap = {
  iphone: 'ios',
  android: 'android',
};

/**
 * 苹果投放banner
 */
export const useAppleDpBanner = () => {
  const osType = osMap[userEnv.getOSInfoObj().type];
  const bannerInfo = ref<BannerInfo | undefined>();

  const initBanner = async () => {
    const bannerList = await getBannerList();
    const finalBannerList = bannerList
      .map((item) => {
        const { jumpUrl, appid, path } = item;
        return {
          ...item,
          jumpInfo: {
            jumpUrl,
            appid,
            path,
          },
        };
      })
      .filter(item => item.osType.includes(osType))
      .slice(0, MAX_BANNER_COUNT);
    if (finalBannerList.length > 0) {
      [bannerInfo.value] = finalBannerList;
    }
  };
  return {
    bannerInfo,
    initBanner,
  };
};

/**
 * 获取banner列表
 */
const getBannerList = async () => {
  const result = await queryDpMessage({
    dpPage: HOME_DP_PAGE_ID,
    dpPositions: [APPLE_BANNER_DP_ID],
  });
  const bannerList = result?.dpList.map(item => ({
    id: item.dpId,
    ...item.contentBaseData,
  })) || [];
  return getConfigWithLang(bannerList, language.getLanguage()) as any;
};
